import { styled } from '@mui/material/styles';

import { Paper } from 'shared/components/Paper';

export const Wrapper = styled(Paper)({
  height: '100%',
  display: 'grid',
  gridTemplateRows: 'auto auto 4fr auto',
  overflow: 'auto',
});
